/*
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-15 13:55:10
 * @LastEditors Cong Yuan wso2848303@163.com
 * @LastEditTime 2025-03-11 15:19:53
 * @Description: 支付方法
 * @FilePath: /hsylc2021/src/utils/pay.js
 */
import qs from 'qs';
import PLAT from './plat';
import { Api, Codes } from '../api';
import { PAY_CHANNELS, PAY_METHODS, WX_OPEN_ID_KEY } from '../constants/pay';
export const METHODS = PAY_METHODS;
export const CHANNEL = PAY_CHANNELS;
export const OPEN_ID_KEY = WX_OPEN_ID_KEY;
export default class {
  /**
   * 构造函数
   * @param {Object} options 参数，具体如下
   * @prop {String} channel 支付渠道
   * @prop {String} orderId 订单号
   * @prop {String} code 线下申请码
   * @prop {Object} payment 接口返回的payment对象，无需赋值
   * @prop {Object} payload 接口返回的payload对象，无需赋值
   * @prop {String} method 支付方式，无需赋值
   * @prop {Object} tempWindow 打开的新窗口，无需赋值
   * @prop {Boolean} listening 是否正在轮询，无需赋值
   * @prop {Function} aliWapCb ali wap 支付唤起回调
   * @prop {Function} wxQrCb wx qr 支付唤起回调
   * @prop {Function} wxWapCb wx wap 支付唤起回调
   * @prop {Function} codeVeriCb code验证后回调
   * @prop {Function} codeUseCb code支付成功后回调
   * @prop {Function} successCb 轮询到支付成功后的回调
   * @prop {Function} errCb 调用接口发生错误时的回调
   */
  constructor(options) {
    let defaults = {
      channel: '',
      orderId: '',
      code: '',
      aliWapCb: null,
      wxQrCb: null,
      wxWapCb: null,
      codeVeriCb: null,
      codeUseCb: null,
      successCb: null,
      wxAppCb: null,
      errCb: null,
      payment: {},
      payload: {},
      paymentId: '',
      method: '',
      tempWindow: null,
      listening: false,
      openId: null,
      wxCode: null,
      returnUrl: window.location.href
    };
    let _options = { ...defaults, ...options };
    for (let key in _options) {
      this[key] = _options[key];
    }
    this.initial();
  }
  setData = (key, value) => {
    this[key] = value;
  };
  openNewWindow = () => {
    if (this.method === METHODS.WAP || this.method === METHODS.WEB) {
      this.tempWindow = true;
    }
  };
  /**
   * @description 舒适化函数并发起支付请求
   * @function initial
   */
  initial = async () => {
    this.setPayMethod();
    this.openNewWindow();
    // 支付渠道为微信并且当前在微信环境下
    if (this.channel === CHANNEL.WX && this.method === METHODS.MP) {
      this.openId = localStorage.getItem(OPEN_ID_KEY);
      if (!this.openId) {
        await this.setWxCode();
      } else {
        await this.startPayment();
      }
    } else {
      await this.startPayment();
    }
  };
  startPayment = async () => {
    let payment = (this.payment = await Api.post.postStudentPayment({
      order_id: this.orderId,
      channel: this.channel,
      method: this.method,
      sdl_code: this.code,
      openid: this.openId,
      return_url: this.returnUrl
    }));
    if (payment.status === Codes.SUCCESS) {
      this.payload = payment.data.payload;
      this.paymentId = payment.data.payment_id;
      switch (this.channel) {
        case CHANNEL.AL: {
          this.aliWapPay();
          this.startListen();
          break;
        }
        case CHANNEL.WX: {
          switch (this.method) {
            case METHODS.WAP: {
              console.log('微信wap支付');
              this.wxWapPay();
              break;
            }
            case METHODS.SCAN: {
              console.log('微信扫码支付');
              this.wxScanPay();
              break;
            }
            case METHODS.MP: {
              console.log('微信公众号支付');
              this.wxMPPay();
            }
          }
          this.startListen();
          break;
        }
        case CHANNEL.SDL: {
          if (this.payload.valid) {
            if (this.codeVeriCb) {
              this.codeVeriCb();
            }
          } else {
            this.errCb('申请码错误！');
          }
          break;
        }
      }
    } else {
      if (this.errCb) {
        this.errCb(payment.msg);
      }
    }
  };
  cleanListen = () => {
    clearInterval(this.polling);
  };
  startListen = () => {
    this.listening = true;
    this.polling = setInterval(async () => {
      let res = await Api.post.postStudentPaymentIsPaid(
        {},
        {
          src: [this.paymentId]
        }
      );
      if (res && res.status === Codes.SUCCESS && res.data) {
        this.listening = false;
        this.cleanListen();
        this.success();
      }
    }, 3000);
  };
  /**
   * @description 支付成功统一触发器
   * @function success
   */
  success = () => {
    if (this.successCb) {
      this.successCb();
    }
  };
  /**
   * @description SDL支付
   * @function CodePay
   */
  CodePay = async () => {
    let res = await Api.post.postStudentSDLCodePay(
      {
        payment_id: this.paymentId
      },
      {
        src: [this.code]
      }
    );
    if (res.status === Codes.SUCCESS) {
      this.successCb();
    }
  };
  /**
   * @description 微信公众号支付
   * @function wxMPPay
   */
  wxMPPay = () => {
    window.WeixinJSBridge.invoke('getBrandWCPayRequest', this.payload, function(res) {
      if (res.err_msg === 'get_brand_wcpay_request:ok') {
        // alert('pay success');
        // 使用以上方式判断前端返回,微信团队郑重提示：
        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
      } else {
        alert('小程序内支付暂时受限，请登录官网完成报名，www.hsylc.cn');
        console.log('js-api支付唤醒失败');
      }
      console.log(res);
    });
    if (this.aliWapCb) {
      this.aliWapCb();
    }
  };
  /**
   * @description 微信wab支付
   * @function wxWapPay
   */
  wxWapPay = () => {
    if (this.tempWindow) {
      window.location.href = this.payload.url;
    }
    if (this.aliWapCb) {
      this.aliWapCb();
    }
    // location.href = this.payload.url;
    // this.wxScanPay();
  };
  /**
   * @description 微信扫码支付
   * @function wxScanPay
   */
  wxScanPay = () => {
    if (this.wxQrCb) {
      this.wxQrCb(this.payload.code_url);
    }
  };
  /**
   * @description ali wab/web 支付
   * @function aliWapPay
   */
  aliWapPay = () => {
    let query = qs.stringify(this.payload.params);
    if (this.tempWindow) {
      window.location.href = `${this.payload.endpoint}?${query}`;
    }
    if (this.aliWapCb) {
      this.aliWapCb();
    }
  };
  /**
   * @description 设置channel
   * @function setPayMethod
   */
  setPayMethod = () => {
    switch (this.channel) {
      case CHANNEL.SDL: {
        this.method = METHODS.CODE;
        break;
      }
      case CHANNEL.AL: {
        if (PLAT.isMobile() || PLAT.isWeiXin()) {
          this.method = METHODS.WAP;
        } else {
          this.method = METHODS.WEB;
        }
        break;
      }
      case CHANNEL.WX: {
        if (PLAT.isWeiXin() && !PLAT.isMobile()) {
          this.method = METHODS.SCAN;
        } else if (PLAT.isWeiXin()) {
          // if (true) {
          this.method = METHODS.MP;
        } else if (PLAT.isMobile()) {
          // this.method = METHODS.WAP;
          this.method = METHODS.WAP; // 暂时无wap支付
        } else {
          this.method = METHODS.SCAN;
        }
        break;
      }
    }
  };
  /**
   * @description 请求接口获取wxcode跳转页面，返回wxcode在页面url参数中
   * @function setWxCode
   */
  setWxCode = async () => {
    let oauth = await Api.get.getPaymentWechatOauth({
      return_url: window.location.origin + '/wx-code-redirect?r=pay/apply'
    });
    if (oauth.status === Codes.SUCCESS) {
      // this.tempWindow.location = oauth.data.wechat_pay_oauth_url;
      window.location.href = oauth.data.wechat_pay_oauth_url;
    }
  };
}
